module.exports = __webpack_public_path__ + "img/roadmap-phase-2-cell-3-icon.ec48e863.webp";